"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceName = void 0;
var DeviceName;
(function (DeviceName) {
    DeviceName["Browser"] = "browser";
})(DeviceName = exports.DeviceName || (exports.DeviceName = {}));
